import { ACCOUNTS_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useAccountsList } from './hook';
import { AccountsListProps } from './props';

export const AccountsList = ({ filters }: AccountsListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useAccountsList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${ACCOUNTS_DETAIL}/${item.row.id}`, '_blank')
            }
        />
    );
};
